<template>
    <div :class="theme.cardContainer">
        <slot></slot>
    </div>
</template>
<script>
import theme from './theme.scss';

export default {
    name: 'card',
    data() {
        return {
            theme,
        }
    }
}
</script>



// WEBPACK FOOTER //
// CardContainer.vue?1e186e5f